const numbers = str => (str ? str.replace(/[^0-9]/g, "") : "");

const validateCPF = strCPF => {
  let sum, rest, i;
  sum = 0;
  if (strCPF == "00000000000") return false;

  for (i = 1; i <= 9; i++)
    sum = sum + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
  rest = (sum * 10) % 11;

  if (rest == 10 || rest == 11) rest = 0;
  if (rest != parseInt(strCPF.substring(9, 10))) return false;

  sum = 0;
  for (i = 1; i <= 10; i++)
    sum = sum + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
  rest = (sum * 10) % 11;

  if (rest == 10 || rest == 11) rest = 0;
  if (rest != parseInt(strCPF.substring(10, 11))) return false;
  return true;
};

const validateCNPJ = cnpj => {
  cnpj = cnpj.replace(/[^\d]+/g, "");

  if (cnpj == "") return false;

  if (cnpj.length != 14) return false;

  if (
    cnpj == "00000000000000" ||
    cnpj == "11111111111111" ||
    cnpj == "22222222222222" ||
    cnpj == "33333333333333" ||
    cnpj == "44444444444444" ||
    cnpj == "55555555555555" ||
    cnpj == "66666666666666" ||
    cnpj == "77777777777777" ||
    cnpj == "88888888888888" ||
    cnpj == "99999999999999"
  )
    return false;

  let size = cnpj.length - 2;
  let numbers = cnpj.substring(0, size);
  let digits = cnpj.substring(size);
  let sum = 0;
  let pos = size - 7;
  let i;
  for (i = size; i >= 1; i--) {
    sum += numbers.charAt(size - i) * pos--;
    if (pos < 2) pos = 9;
  }
  let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (result != digits.charAt(0)) return false;

  size = size + 1;
  numbers = cnpj.substring(0, size);
  sum = 0;
  pos = size - 7;
  for (i = size; i >= 1; i--) {
    sum += numbers.charAt(size - i) * pos--;
    if (pos < 2) pos = 9;
  }
  result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (result != digits.charAt(1)) return false;

  return true;
};

const verifyAge = birth => {
  const split = birth.split("/");
  const year = Number(split[2]);
  const month = Number(split[1]);
  const day = Number(split[0]);

  const today = new Date();
  const age = today.getFullYear() - year;
  const m = today.getMonth() - month;
  const d = today.getDate() - day;

  if (m < 0 || (m === 0 && d < 0)) return age - 1;

  return age;
};

export const formRules = {
  // data() {
  //   return {
  //     validationMessages: v => !!v ||
  //       razao_social: "Teste Pires",
  //     },
  //   };
  // },
  computed: {
    rules() {
      return {
        required: v => {
          if (v === 0) return true;
          return !!v || this.$t("common.required_field");
        },
        totalRequired: v => {
          const normalizedValue = typeof v === "string" ? v.trim() : v;
          const isID = /^[a-zA-Z0-9]{3,}$/.test(normalizedValue);

          if (isID) {
            return (
              (normalizedValue !== null &&
                normalizedValue !== undefined &&
                normalizedValue !== "") ||
              this.$t("common.required_field")
            );
          }

          const numericValue = parseFloat(
            typeof normalizedValue === "string"
              ? normalizedValue.replace(",", ".")
              : normalizedValue
          );

          return (
            (normalizedValue !== null &&
              normalizedValue !== undefined &&
              normalizedValue !== "" &&
              numericValue !== 0) ||
            this.$t("common.required_field")
          );
        },
        nonNegativeNumber: value => {
          const isValidNumber =
            value !== undefined && value !== null && +value >= 0;
          const containsInvalidCharacters = /[.,]/.test(value);
          if (isValidNumber && !containsInvalidCharacters) {
            return true;
          }
          return this.$t("negative-number");
        },
        maxLimit: value => {
          return (
            +value.replace(",", ".") <= 100 ||
            this.$t("common.value-cant-be-higher-than-100")
          );
        },
        validURL: value => {
          const isValidURL =
            /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)([/\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/i.test(
              value
            );
          return isValidURL || this.$t("invalid-url");
        },
        maxLengthSlug: v =>
          v.length <= 65 || this.$t("common.max_length", { max: 65 }),
        requiredField: inputName => {
          return v => !!v || `Preencha ${inputName} corretamente`;
        },
        requiredSelect: inputName => {
          return v => !!v || `Selecione ${inputName}`;
        },
        requiredStore: v => {
          if (v === 0) return;
          return !!v || this.$t("common.required_field");
        },
        requiredArray: v => v?.length > 0 || this.$t("common.required_field"),
        requiredZero: v =>
          v || v === 0 ? true : this.$t("common.required_field"),
        requiredPrice: value => {
          const numericValue = parseFloat(value.replace(",", "."));

          return numericValue > 0 || this.$t("common.required_field");
        },
        minQuantity: min => v =>
          (v ? v >= min : true) || `Mínimo de ${min} quantidade`,
        email: v =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          this.$t("common.invalid_email"),
        min: min => v =>
          (v ? v.length >= min : true) || `Mínimo de ${min} caracteres`,
        max: max => v =>
          (v ? v.length <= max : true) || `Máximo de ${max} caracteres`,
        cnpj: v => validateCNPJ(numbers(v)) || "CNPJ inválido",
        cpf: v => validateCPF(numbers(v)) || "CPF inválido",
        passport: v => v.length === 8 || "Passaporte inválido",
        cellphone: v => numbers(v).length === 11 || "Celular inválido",
        cardNumber: v =>
          numbers(v).length === 16 || "Número do cartão inválido",
        cardExpireDate: v =>
          numbers(v).length === 4 || "Data de expiração inválida",
        cardCVV: v => numbers(v).length === 3 || "CVV inválido",
        birth: v => {
          const error = "Data de nascimento inválida";
          const erro = "Você deve ter mais de 18 anos";

          if (!v) return error;
          if (verifyAge(v) < 18) return erro;

          const split = v.split("/");

          if (split.length !== 3) return error;

          const year = Number(split[2]);

          if (year < 1900 || year > new Date().getFullYear()) return error;

          const month = Number(split[1]);

          if (month <= 0 || month > 12) return error;

          const day = Number(split[0]);

          if (day <= 0 || day > 31) return error;

          return true;
        },
        maxNumber: limit => v =>
          (v ? v <= limit : true) || this.$t("sales.limit-is", { limit }),
        specialCharacters: v => {
          const specialCharacters = /^[a-zA-Z0-9)+=._-]+$/;
          return (
            specialCharacters.test(v) || this.$t("common.special-characters")
          );
        },
      };
    },
  },
};

export default formRules;
